import { PERMISSIONS } from "@/constants/permissions";

/** Scope único alineado con `IndustrialFormulaController` y seed tenant. */
export const INDUSTRIAL_FORMULA_READ_PERMISSION =
  PERMISSIONS.INDUSTRIAL_FORMULA.READ;
export const INDUSTRIAL_FORMULA_CREATE_PERMISSION =
  PERMISSIONS.INDUSTRIAL_FORMULA.CREATE;
export const INDUSTRIAL_FORMULA_UPDATE_PERMISSION =
  PERMISSIONS.INDUSTRIAL_FORMULA.UPDATE;
export const INDUSTRIAL_FORMULA_DELETE_PERMISSION =
  PERMISSIONS.INDUSTRIAL_FORMULA.DELETE;
